import React from "react";
import { FaCrown } from "react-icons/fa6";
import { IoMdLock } from "react-icons/io";

// Components
import DiamondsSvg from "./DiamondsSvg";

// Styles
import styles from "./Badge.module.css";


const Badge = ({ familiarity, isLocked }) => {
  const isCompleted = familiarity === 100;
  const borderColor = isLocked ? 'border-gray-500' : 'border-blue-500';
  const backgroundColor = isLocked ? 'bg-gray-200' : isCompleted ? 'bg-blue-600' : 'bg-white';

  const renderIcon = () => {
    if (isLocked) return <IoMdLock className="text-gray-500 text-md" />;
    if (isCompleted) return <FaCrown className="text-white text-md" />;

    let diamondCount = 0;
    if (0 <= familiarity && familiarity < 20) diamondCount = 1;
    else if (20 <= familiarity && familiarity < 60) diamondCount = 2;
    else if (60 <= familiarity && familiarity < 80) diamondCount = 3;
    else if (80 <= familiarity && familiarity < 100) diamondCount = 4;

    return (
      <div className={`${styles.diamondContainer}`}>
        <DiamondsSvg count={diamondCount} />
      </div>
    )
  }

  const renderProgress = () => {
    if (isLocked) return null;
    if (isCompleted) return null;
    else return (
      <div className="absolute bottom-0 w-full rounded-lg pointer-events-none"
        style={{
          height: '100%',
          background: `linear-gradient(to top, #B2DDFF, transparent ${familiarity}%)`,
        }}
      />
    )
  }

  const renderFamiliarity = () => {
    if (isLocked) return null;

    let style = ''
    if (isCompleted) {
      style = styles.complete
    } else if (familiarity >= 0 && familiarity < 20) {
      style = styles.red
    } else if (familiarity >= 20 && familiarity < 40) {
      style = styles.orange
    } else if (familiarity >= 40 && familiarity < 60) {
      style = styles.yellow
    } else if (familiarity >= 60 && familiarity < 100) {
      style = styles.blue
    }

    return (
      <div className={`${styles.familiarity} rounded-full pointer-events-none ${style}`}>
        <p className={`text-xs`}>{familiarity}%</p>
      </div>
    )
  }

  return (
    <div className={`${styles.badge} ${backgroundColor} border-2 ${borderColor}`}>
      {renderProgress()}

      {renderIcon()}

      {renderFamiliarity()}
    </div>
  );
};

export default Badge;
